<template>
    <!-- a click in the menu marks the next navigation as a menu one (header breadcrumb, helpers/crumbTrail) -->
    <div class="w-full" @click.capture="markMenuNav">
        <!-- Sidebar - Added transition classes here -->
        <div
class="relative text-white transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
            :class="isCollapsed ? 'w-[72px]' : 'laptop:w-96 largeDesktop:w-80 mobile:w-full'"
>
<!-- Toggle Button - Added transition classes -->
            <div class="absolute -top-20 left-0 flex justify-start px-2">
                <button
                    class="mobile:hidden laptop:block largeDesktop:block focus:outline-none text-white hover:text-gray-300 transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
                    :class="{ 'rotate-180': isCollapsed }" @click="toggleSidebar"
>
                    <img
:src="isCollapsed ? showIcon : hideIcon" alt="Toggle Icon"
                        class="h-16 w-16 transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
>
                </button>
            </div>

            <!-- Menu Items - Added transition classes -->
            <nav
:class="isCollapsed ? 'bg-white rounded-full px-[7px] py-[3px]' : 'bg-transparent p-3'"
                class="transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
>
                <ul class="flex flex-col gap-2 p-0 m-0">
                    <li
v-for="item in menuItems" :key="item.name"
                        class="menuList relative group mobile:border-[1px] mobile:rounded-2xl tablet:rounded-2xl mobile:py-0 tablet:py-1 tablet:transition-all tablet:duration-500 tablet:ease-[cubic-bezier(0.4,0,0.2,1)]"
                        :class="getMenuItemClasses(item)" :style="getMenuItemStyles(item)"
>
<!-- Main link - Added transition classes (a real <a href> when it navigates, so it can open in a new tab) -->
                        <component
:is="topLink(item) ? 'router-link' : 'div'" :to="topLink(item) || undefined" active-class="" exact-active-class=""
                            :class="isCollapsed ? '!border-0 !bg-transparent !p-0' : 'mobile:p-1 tablet:p-2 flex-row'"
                            class="block no-underline text-inherit transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
                            @click="menuClicked(item, $event)"
>
                            <div
class="flex items-center cursor-pointer transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
                                :class="isCollapsed ? '!gap-0 w-auto' : 'gap-2 w-full'"
>
                                <!-- Icon container -->
                                <div
                                    class="mobile:min-w-[40px] mobile:min-h-[40px] tablet:min-w-[58px] tablet:min-h-[58px] largeDesktop:min-w-[58px] largeDesktop:min-h-[58px] transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] overflow-hidden relative"
>
                                    <img
:src="item.icon" :alt="item.name"
                                        class="mobile:w-[40px] mobile:h-[40px] tablet:min-w-[58px] tablet:min-h-[58px] largeDesktop:min-w-[58px] largeDesktop:min-h-[58px] transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
>
                                </div>
                                <!-- Text and label - Animate opacity for smoother disappearance -->
                                <div
class="flex items-center justify-between w-full transition-all duration-100 ease-[cubic-bezier(0,0,0,0.5)]"
                                    :class="isCollapsed ? 'opacity-0 absolute' : 'opacity-100 relative'"
>
                                    <span
                                        class="text-[16px] font-roboto font-bold text-black-100 transition-all duration-100 ease-[cubic-bezier(0,0,0,0.5)]"
>
                                        {{ item.name }}
                                        <span
v-if="item.comingSoon"
                                            class="text-xs  ml-1 font-roboto text-[#999999]"
>(Coming
                                            Soon)</span>
                                    </span>
                                    <div class="flex items-center gap-3">
                                        <span
v-if="item.label"
                                            class="inline-block text-sm px-2 rounded-full text-white bg-purple-400 transition-all duration-100 ease-[cubic-bezier(0,0,0,0.5)]"
>
                                            {{ item.label }}
                                        </span>
                                        <!-- <div v-if="!isCollapsed" @click="handleMenuClick(item)"
                                            class="transition-all duration-100 ease-[cubic-bezier(0,0,0,0.5)] flex items-center justify-center w-8 h-8 transform"
                                            :class="{ 'rotate-0': item.submenu && (!isCollapsed && activeMenu === item.name), 'rotate-180': !(item.submenu && (!isCollapsed && activeMenu === item.name)) }">
                                            <i
                                                class="fa fa-angle-up !text-[30px] font-bold text-gray-600 transition-all duration-500 ease-[cubic-bezier(0,0,0,0.5)]"></i>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </component>

                        <!-- Submenu - Added transition classes -->
                        <ul
v-if="item.name != 'Home Essentials Bundles'"
                            class="p-2 flex flex-col gap-1 transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] origin-top"
>
                            <div v-for="sub in item.submenu" :key="sub.name">
                                <li
class="relative group/submenu text-md font-roboto pl-6 pr-1 py-1.5 cursor-pointer rounded-lg border border-[#CCCCCC] bg-white text-black-100 transition-all duration-300"
                                    :class="{ 'active-route-class': isRouteActive(sub) }"
                                    :style="(sub._hover || isRouteActive(sub)) ? 'background-color: ' + (item.menuHoverColor || '#4b5563') + ' !important; color: white !important;' : ''"
                                    @mouseover="sub._hover = true" @mouseleave="sub._hover = false"
                                    @click.stop="sub.submenu ? null : handleSubmenuClick(sub, $event)"
>
                                    <!-- Submenu content (leaf: real <a href>; the li click covers its padding) -->
                                    <component
:is="!sub.submenu && linkTo(sub.route) ? 'router-link' : 'div'"
                                        :to="(!sub.submenu && linkTo(sub.route)) || undefined" active-class="" exact-active-class=""
                                        class="flex justify-between items-center no-underline text-inherit transition-all duration-800">
                                        <div class="rounded px-1.5 py-0.5 transition-all duration-300">
                                            {{ sub.name }}
                                            <span
v-if="sub.comingSoon"
                                                class="text-xs  ml-1 font-roboto text-[#999999] group-hover/submenu:text-white transition-all duration-300"
>(Coming
                                                Soon)</span>
                                        </div>
                                        <div
v-if="sub.submenu" class="transition-all duration-800 flex items-center justify-center w-6 h-6"
                                            :class="{ 'rotate-180': sub.isOpen }"
                                            @click.stop="handleSubmenuClick(sub)"
>
                                            <i
class="fa fa-angle-down !text-[24px] font-bold group-hover/submenu:!text-white transition-all duration-300"
                                                :class="isRouteActive(sub) ? 'text-white' : 'text-gray-600'"
/>
                                        </div>
                                        <div
                                            class="absolute left-2 h-full flex items-center transition-all duration-300"
>
                                            <span
class="block w-2 h-2 rounded-full transition-all duration-300" :style="{
                                                backgroundColor: (sub._hover || isRouteActive(sub)) ? '#ffffff' : (item.menuHoverColor || '#4b5563')
                                            }"
/>
                                        </div>
                                    </component>
                                </li>

                                <!-- Nested Submenu - Added transition classes -->
                                <div
v-if="sub.submenu && sub.isOpen"
                                    class="py-3 transition-all duration-300 ease-in-out origin-top"
>
                                    <ul
                                        class="ml-4 mt-1 px-2 py-0 flex flex-col gap-1 relative rounded-lg transition-all duration-300"
>
                                        <div
                                            class="w-[3px] h-full absolute left-2 top-0 rounded-full bg-gray-300 transition-all duration-300"
/>
                                        <li
v-for="nestedSub in sub.submenu" :key="nestedSub.name"
                                            class="relative group-childMenu text-md font-roboto flex justify-between items-center pl-3 pr-3 py-1.5 cursor-pointer rounded-lg bg-white text-black-100 transition-all duration-300"
                                            :class="{ 'active-route-class': isRouteActive(nestedSub) }"
                                            :style="(nestedSub._hover || isRouteActive(nestedSub)) ? 'color: ' + (item.menuHoverColor || '#4b5563') + '; ' : ''"
                                            @mouseover="nestedSub._hover = true" @mouseleave="nestedSub._hover = false"
                                            @click="handleSubmenuClick(nestedSub, $event)"
>
                                            <component
:is="!nestedSub.submenu && linkTo(nestedSub.route) ? 'router-link' : 'div'"
                                                :to="(!nestedSub.submenu && linkTo(nestedSub.route)) || undefined" active-class="" exact-active-class=""
                                                class="flex flex-1 justify-between items-center no-underline text-inherit">
                                            {{ nestedSub.name }}
                                            <span
v-if="nestedSub.label"
                                                class="inline-block text-sm min-w-10 text-center font-bold px-2 rounded-full text-purple-400 bg-gray-200 transition-all duration-100 ease-[cubic-bezier(0,0,0,0.5)]"
>
                                                {{ getPlanCount(nestedSub.label) }}
                                            </span>
                                            <div
                                                class="absolute top-0 left-0 h-full flex items-center transition-all duration-300"
>
                                                <span
                                                    class="block w-[3px] h-full rounded-full transition-all duration-300"
                                                    :style="{
                                                        backgroundColor: (nestedSub._hover || isRouteActive(nestedSub)) ? item.menuHoverColor : '#d1d5db'
                                                    }"
/>
                                            </div>
                                            </component>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ul>

                        <!-- Submenu on hover (collapsed only) - Added transition classes -->
                        <!-- <div v-if="isCollapsed && item.submenu"
                            class="collapseSubMenu absolute left-full top-0 bg-white text-black-100 rounded shadow-lg z-50 w-max opacity-0 invisible group-hover:!visible  group-hover:!opacity-100 transition-opacity duration-300">
                            <ul class="p-2 transition-all duration-300">
                                <li v-for="sub in item.submenu" :key="sub.name" class="relative group/subMenu"
                                    @mouseover="sub._hover = true" @mouseleave="sub._hover = false">

                                    <div :style="sub._hover
                                        ? 'background-color:' + (item.menuHoverColor || '#4b5563') + '!important; color: #fff !important;'
                                        : ''" class="text-md py-1 px-2 hover:bg-gray-600 cursor-pointer rounded">
                                        {{ sub.name }}
                                    </div>
                                    <div v-if="sub.submenu"
                                        class="nested-collapse-submenu absolute left-full top-0 ml-1 bg-white rounded shadow-lg opacity-0 group-hover/subMenu:!opacity-100 transition-opacity duration-300">
                                        <ul class="p-2 transition-all duration-300">
                                            <li v-for="nestedSub in sub.submenu" :key="nestedSub.name"
                                                class="text-md py-1 px-2 hover:bg-gray-600 cursor-pointer rounded transition-all duration-300">
                                                {{ nestedSub.name }}
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div> -->
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>


<script>
import { markMenuNav } from "@/helpers/crumbTrail";
import workOrderIcon from "../assets/images/work-order-icon.png"
import protectionPlanIcon from "../assets/images/protection-plan-icon.png"
import serviceAgreementIcon from "../assets/images/service-agreement-icon.png"
import systemDesignerIcon from "../assets/images/system-designer-icon.png"
import adminUtilitiesIcon from "../assets/images/admin-utilities-icon.png"
import priceBookIcon from "../assets/images/pricebook-icon.png"
import navShowIcon from "../assets/images/nav-show-icon.svg"
import navHideIcon from "../assets/images/nav-hide-icon.svg"
import { mapActions, mapGetters } from "vuex";
import { isNewTabClick } from "@/helpers/newTabClick";
import { loadOnce } from "@/helpers/loadOnce";
import { Offcanvas } from 'bootstrap'
import bundlesIcon from "../assets/images/bundles-icon.png"

export default {
    props: ['setSideMenuClicked'],
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')) ?? null,
            isCollapsed: false,
            activeMenu: 'Home Essentials Bundles',
            showIcon: navShowIcon,
            hideIcon: navHideIcon,
            isHovered: false,
            cartCount: {},
            menuItems: []
        };
    },
    computed: {
        ...mapGetters(["cartCountResponse", "userObject"]),
        currentRoute() {
            return this.$route.path;
        },


    },
    watch: {
        '$route.path'(newPath) {
            this.activateMenuByRoute(); // Re-activate menu on route change
        },

        cartCountResponse: function (data) {
            this.cartCount = this.cartCountResponse
        },

        userObject: function () {
            localStorage.setItem('user', JSON.stringify(this.userObject))
            this.setMenu()
        },
    },
    created() {
        this.initSubmenus(); // Initialize submenu hover states
    },

    mounted() {
        loadOnce('profile', () => this.getProfile({}))
        this.setMenu()
        this.$nextTick(() => {
            this.activateMenuByRoute(); // Delay to ensure router is fully ready
            const is_from_mobile = localStorage.getItem("is_from_mobile", 0) ?? 0
            if ((localStorage.getItem('user') ?? null) != null && is_from_mobile != '1') {
                if (this.$helper.isEmpty(this.$store.state.product.cartCountResponse)) {
                    loadOnce('cartCount', () => this.getCartCount({}));
                } else {
                    this.cartCount = this.$store.state.product.cartCountResponse
                }
            }
        });


    },

    methods: {
        markMenuNav,
        ...mapActions(["getCartCount", "setSelectedProtectionPlan", "getProfile"]),

        // in-app path → route location for <router-link> (same query the push used); '#', external or empty → null
        linkTo(route) {
            return typeof route === 'string' && route.startsWith('/') && !route.startsWith('//')
                ? { path: route, query: { is_from_mobile: '1' } }
                : null;
        },
        topLink(item) {
            return item.name == 'Home Essentials Bundles' ? this.linkTo("/protection-plan/nrg/bundle-list") : null;
        },

        menuClicked(item, e){

            if (item.name == 'Home Essentials Bundles') {
                if (isNewTabClick(e)) return;
                // the <router-link> navigates; only close the off-canvas menu here

                const offcanvasElement = document.getElementById('offcanvasNavbar');
                const offcanvasInstance = Offcanvas.getInstance(offcanvasElement)
                    || new Offcanvas(offcanvasElement);

                offcanvasInstance.hide();
                this.activeMenu = this.activeMenu === item.name ? null : item.name;
            }
        },

        getPlanCount(plan) {
            return this.cartCount[plan] ?? null
        },

        toggleSidebar() {
            this.isCollapsed = !this.isCollapsed;
            this.activeMenu = null;
            this.$emit('sidebar-collapse', this.isCollapsed);
        },
        handleMenuClick(item) {
            if (item.route && !item.submenu) {
                if (this.setSideMenuClicked) {
                    this.setSideMenuClicked()
                }
                this.$router.push(item.route);
                return;
            }
            this.activeMenu = this.activeMenu === item.name ? null : item.name;
        },
        handleSubmenuClick(subItem, e) {

            if (subItem.submenu) {
                subItem.isOpen = !subItem.isOpen;
            } else if (subItem.route) {
                const viaLink = e && e.target && e.target.closest && e.target.closest('a');
                if (viaLink && isNewTabClick(e)) return;
                if (this.setSideMenuClicked) {
                    this.setSideMenuClicked()
                }

                const offcanvasElement = document.getElementById('offcanvasNavbar');
                const offcanvasInstance = Offcanvas.getInstance(offcanvasElement)
                    || new Offcanvas(offcanvasElement);

                offcanvasInstance.hide();


                // a click on the <a> is navigated by router-link; padding around it lands here
                if (!viaLink) {
                    this.$router.push({
                        path: subItem.route,
                        query: {
                            is_from_mobile: '1'
                        }
                    });
                }

                if (subItem.label == 'hvac' || subItem.label == 'plumbing' || subItem.label == 'electric') {
                    this.setSelectedProtectionPlan(subItem)
                }


                if (this.isCollapsed) {
                    this.activeMenu = null;
                }
            }
        },
        getMenuItemClasses(item) {
            const isActive = this.isRouteActive(item);
            return [
                this.isCollapsed ? '!border-0 !bg-transparent' : ' bg-white mobile:shadow-[0_0px_15px_-5px_#b5b2b2]',
                isActive ? 'active-route-class' : '',
            ];
        },
        getMenuItemStyles(item) {
            return item.submenu && (this.activeMenu === item.name)
                ? {
                    'border-color': item.menuHoverColor || '#4b5563 ',
                    'border-style': 'solid',
                    'border-radius': '1rem'
                }
                : {};
        },

        isRouteActive(item) {
            if (item.route) return this.currentRoute === item.route;
            if (item.submenu) return item.submenu.some(sub => this.isRouteActive(sub));
            return false;
        },

        initSubmenus() {
            const walk = items => {
                items.forEach(item => {
                    item._hover = false;
                    if ('isOpen' in item) item.isOpen = false;
                    if (item.submenu) walk(item.submenu);
                });
            };
            walk(this.menuItems);
        },

        activateMenuByRoute() {
            const route = this.currentRoute;
            const findAndActivate = (items, parentChain = []) => {
                for (const item of items) {
                    if (item.route === route) {
                        parentChain.forEach(parent => {
                            if ('isOpen' in parent) parent.isOpen = true;
                        });
                        if (parentChain.length > 0) {
                            this.activeMenu = parentChain[0].name;
                        }
                        return true;
                    }

                    if (item.submenu) {
                        const found = findAndActivate(item.submenu, [...parentChain, item]);
                        if (found) return true;
                    }
                }
                return false;
            };

            findAndActivate(this.menuItems);
        },

        setMenu() {
            this.menuItems = []

            this.addMenu({
                name: 'Home Essentials Bundles',
                icon: bundlesIcon,
                menuHoverColor: '#A793DB',
                label: '',
                submenu: []
            })

            this.addMenu({
                name: 'Protection Plans',
                icon: protectionPlanIcon,
                menuHoverColor: '#A793DB',
                label: 'New',
                submenu: []
            });

            this.addSubMenu('Protection Plans', {
                name: 'Plans',
                routeName: 'plan',
                _hover: false,
                isOpen: false,
                submenu: [
                    { name: 'HVAC', route: '/protection-plan/hvac', _hover: false, label: 'hvac' },
                    { name: 'Plumbing', route: '/protection-plan/plumbing', _hover: false, label: 'plumbing' },
                    { name: 'Electric', route: '/protection-plan/electric', _hover: false, label: 'electric' }
                ]
            })

            this.addSubMenu('Protection Plans', { name: 'Protection Plans - Sales History', route: '/protection-plan/sales-history', _hover: false })
            if ((localStorage.getItem('user') ?? null) != null) {
                let user = JSON.parse(localStorage.getItem('user'))
                if (user.user.is_show_commission == '1') {
                    this.addSubMenu('Protection Plans', { name: 'Commissions', route: '/protection-plan/commissions', _hover: false })
                }
            }
            // remove submenu
            // this.removeSubMenu('Protection Plans', 'Commissions');
        },

        addMenu(item) {
            this.menuItems.push(item);
        },

        addSubMenu(parentName, item) {
            const parent = this.findMenuByName(parentName, this.menuItems);
            if (parent) {
                parent.submenu.push(item);
            }
        },

        removeSubMenu(parentName, subMenuName) {
            const parent = this.findMenuByName(parentName, this.menuItems);
            if (parent && parent.submenu) {
                parent.submenu = parent.submenu.filter(sub => sub.name !== subMenuName);
            }
        },

        findMenuByName(name, items) {
            for (let item of items) {
                if (item.name === name) return item;
                if (item.submenu && item.submenu.length) {
                    let found = this.findMenuByName(name, item.submenu);
                    if (found) return found;
                }
            }
            return null;
        },
    }
};
</script>
